module.exports = __webpack_public_path__ + "static/media/16463353_373082306386306_4391796863959948255_o (2)-min.9f8374fd.jpg";